 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_CONTENTS from '@/components/html/03_Contents'
 import HTML04_FOREWORD from '@/components/html/04_Foreword'
 import HTML05_INTRODUCTION__THE_ARRIVAL_OF_THE from '@/components/html/05_Introduction__The_Arrival_of_the'
 import HTML06_1__SETTING_THE_STAGE from '@/components/html/06_1__Setting_the_Stage'
 import HTML07_2___ARISE__LIGHT_OF_THE_SENSES from '@/components/html/07_2___Arise__Light_of_the_Senses'
 import HTML08_3__WHY_SYMPHONY from '@/components/html/08_3__Why_Symphony'
 import HTML09_INTERLUDE___BEHIND_THE_SCENES__A from '@/components/html/09_Interlude___Behind_the_Scenes__A'
 import HTML10_4__GOD_OR_DEMON from '@/components/html/10_4__God_or_Demon'
 import HTML11_5__APPROACHING_THE_INEXPRESSIBLE from '@/components/html/11_5__Approaching_the_Inexpressible'
 import HTML12_6__QUESTIONS_OF_IDENTITY from '@/components/html/12_6__Questions_of_Identity'
 import HTML13_7__THE_SHADOW_FALLS from '@/components/html/13_7__The_Shadow_Falls'
 import HTML14_8___TO_LIVE_FOR_YOU__TO_DIE_FOR from '@/components/html/14_8___To_Live_for_You__To_Die_for'
 import HTML15_CODA__14_SEPTEMBER_1910_18_MAY_1 from '@/components/html/15_Coda__14_September_1910_18_May_1'
 import HTML16_NOTES from '@/components/html/16_Notes'
 import HTML17_ACKNOWLEDGEMENTS from '@/components/html/17_Acknowledgements'
 import HTML18_INDEX from '@/components/html/18_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/03_Contents",
 			"name" : "html/03_Contents",
 			"component" : HTML03_CONTENTS
 		},
 		{
 			"path" : "/html/04_Foreword",
 			"name" : "html/04_Foreword",
 			"component" : HTML04_FOREWORD
 		},
 		{
 			"path" : "/html/05_Introduction__The_Arrival_of_the",
 			"name" : "html/05_Introduction__The_Arrival_of_the",
 			"component" : HTML05_INTRODUCTION__THE_ARRIVAL_OF_THE
 		},
 		{
 			"path" : "/html/06_1__Setting_the_Stage",
 			"name" : "html/06_1__Setting_the_Stage",
 			"component" : HTML06_1__SETTING_THE_STAGE
 		},
 		{
 			"path" : "/html/07_2___Arise__Light_of_the_Senses",
 			"name" : "html/07_2___Arise__Light_of_the_Senses",
 			"component" : HTML07_2___ARISE__LIGHT_OF_THE_SENSES
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js